import {
    InvoiceItem,
    InvoiceItemClassification,
    InvoiceItemInventory,
    InvoiceItemPrices,
    InvoiceItemService,
    InvoiceItemType,
    InvoiceItemTypes,
    PriceBreak,
    UnitOfMeasure,
} from '../../../datasource';
import { Exclude, Transform, TransformFnParams, Type, TypeHelpOptions } from 'class-transformer';

class AnimanaInvoiceItemUnitOfMeasure extends UnitOfMeasure {
    pimsGeneratedId: string;
}

class AnimanaInvoiceItemInventory extends InvoiceItemInventory {
    @Type(() => AnimanaInvoiceItemUnitOfMeasure)
    unitOfMeasure?: AnimanaInvoiceItemUnitOfMeasure = new AnimanaInvoiceItemUnitOfMeasure();
}

class AnimanaInvoiceItemClassification extends InvoiceItemClassification {
    pimsGeneratedId: string;
}

class AnimanaInvoiceItemSubClassification extends InvoiceItemClassification {
    pimsGeneratedId: string;
}

class AnimanaInvoiceItemType extends InvoiceItemType {
    id: InvoiceItemTypes;
}

class AnimanaInvoiceItemPrices extends InvoiceItemPrices {
    @Exclude()
    itemTypeId: string;

    minimumPrice: number;

    dispensingFee?: number;

    priceBreaks: PriceBreak[] = [];
}

export class AnimanaInvoiceItem extends InvoiceItem {
    constructor() {
        super();
        console.warn('!!! - AnimanaInvoiceItem constructor - !!!');
    }

    @Type(() => AnimanaInvoiceItemClassification)
    classification: AnimanaInvoiceItemClassification;

    @Type(() => AnimanaInvoiceItemSubClassification)
    subClassification: AnimanaInvoiceItemSubClassification | null = null;

    hospitalDescription: string;

    @Type(() => AnimanaInvoiceItemType)
    itemType: AnimanaInvoiceItemType;

    @Transform((params: TransformFnParams) => {
        return Object.assign(params?.value || {}, { itemTypeId: params.obj?.itemType?.id });
    })
    @Type(() => {
        return AnimanaInvoiceItemPrices;
    })
    prices: AnimanaInvoiceItemPrices;

    @Type((opts?: TypeHelpOptions) => {
        switch (String(opts?.newObject.itemType.id)) {
            case String(InvoiceItemTypes.Inventory):
                return AnimanaInvoiceItemInventory;
            case String(InvoiceItemTypes.Service):
                return InvoiceItemService;
            default:
                return Function;
        }
    })
    typeDetails: AnimanaInvoiceItemInventory | InvoiceItemService = {};
}
